export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-closed-caption-7805d80522d9ecd1d328cc0c3bb15bbe.svg";